module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"disabled":"disabled","trainingModuleReferences":"Module references","trainingPathReferences":"Path references"},"fr":{"disabled":"désactivée","trainingModuleReferences":"Références de modules","trainingPathReferences":"Références de parcours"}}')
  delete Component.options._Ctor
}
